import axios from 'axios'
import { Footprint } from '../../models/footprint'
import { API_ROUTES } from '../routes'

export const updateFootprint = (customerId: string, footprint: Footprint) => {
  return axios.post(API_ROUTES.CUSTOMER + customerId + '/footprint', footprint)
}
